import type { Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import type { ValidatorComponentProps } from 'react-material-ui-form-validator';
import { TextValidator } from 'react-material-ui-form-validator';

export const inputBoxStyles = ({
  theme,
  margin,
}: {
  theme: Theme;
  margin: 'none' | 'dense' | 'normal' | undefined;
}) => ({
  maxWidth: 768,
  width: '100%',
  margin: margin === 'none' ? 0 : '0 0 16px',
  [theme.breakpoints.down('md')]: {
    margin: ({ margin }: { margin: 'none' | 'dense' | 'normal' | undefined }) => (margin === 'none' ? 0 : '0 0 16px'),
    maxWidth: '100%',
  },
  '& .MuiInputLabel-outlined': {
    transform: 'translate(14px, 12px) scale(1)',
  },
  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    transform: 'translate(14px, -8px) scale(0.75)',
  },
  '& .MuiInputBase-root .MuiOutlinedInput-input': {
    height: 30,
    padding: '9px 14px',
  },
  '& .MuiFilledInput-root': {
    backgroundColor: 'transparent',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    fontSize: '0.6875rem',
  },
});

export const StyledTextField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'margin',
})(({ theme, margin }) => ({
  ...inputBoxStyles({ theme, margin }),
}));

export const StyledTextValidator = styled(TextValidator)(({ theme, margin }) => ({
  ...inputBoxStyles({ theme, margin }),
}));

export type TStyledTextValidator = ValidatorComponentProps;
